module.exports = __webpack_public_path__ + "img/task-1-g.a314df52.png";